module.exports = __webpack_public_path__ + "media/apps/gif-de920bc5.png";